import {createTheme, responsiveFontSizes} from '@mui/material'

export const theme = createTheme({
    typography: {
        button: {
            textTransform: 'none',
        },
        fontFamily: '\'Poppins\', sans-serif'
    },

    palette: {
        mode: 'light',
        primary: {
            main: '#2BE000',
            light: '#43FF16',
            dark: '#21AD02',
            100: '#E6FFDF',
            200: '#BDFFAD',
            300: '#95FF7A',
            500: '#01e675',
            400: '#6CFF47',
            800: '#197A01',
            900: '#0D4701',
            contrastText: '#000000',
        },
        secondary: {
            main: '#393CA2',
            dark: '#2B2749',
            light: '#5B5CC4',
            100: '#F0F0FA',
            200: '#CACBEC',
            300: '#A5A6DF',
            400: '#8081D0',
            800: '#1F2056',
            // 900: '#15163B',
            900: '#2B2749',
        },
        error: {
            main: '#E9132D',
            dark: '#A91123',
            light: '#F9C4CB',
        },
        success: {
            main: '#17AD57',
            dark: '#197942',
            light: '#DBFDD7',
        },
        warning: {
            main: '#F5C30F',
            dark: '#BE990E',
            light: '#FDF1C3',
        },
        info: {
            main: '#5B99FF',
            dark: '#3F70C1',
            light: '#D6E4FF',
            900: '#393CA2'
        },
        text: {
            primary: '#1A1A1A',
            secondary: '#FFFFFF',
            disabled: '#999999',
        },
        background: {
            default: '#FFFFFF',
            paper: '#ffffff',
        },
        grey: {
            100: '#E6E6E6',
            200: '#CCCCCC',
            300: '#B3B3B3',
            500: '#808080',
            600: '#666666',
            700: '#4D4D4D',
            800: '#333333',
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
    components: {

        MuiTextField: {
            defaultProps: {
                size: 'small',
                variant: 'outlined',
                inputProps: {
                    autoComplete: 'off'
                }
            },
        },
        MuiTypography: {
            defaultProps: {
                variant: 'body2'
            },
        },
        MuiMenu: {
            defaultProps: {
                elevation: 0,
                transformOrigin: {horizontal: 'right', vertical: 'top'},
                anchorOrigin: {horizontal: 'right', vertical: 'bottom'}
            }
        },

        MuiButton: {
            defaultProps: {
                size: 'small'
            }
        },

        MuiCheckbox: {
            defaultProps: {
                color: 'secondary',
                size: 'small'
            },
            styleOverrides: {
                root: ({theme}) => ({
                    color: theme.palette.grey[300]
                }),
                checked: ({theme}) => ({
                    background: theme.palette.grey[300]
                }),
            }
        },

        MuiRadio: {
            defaultProps: {
                color: 'secondary',
                size: 'small'
            },
            styleOverrides: {
                root: ({theme}) => ({
                    color: theme.palette.grey[300]
                }),
                checked: ({theme}) => ({
                    background: theme.palette.grey[300]
                }),
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: ({theme}) => ({
                    color: theme.palette.secondary.dark,
                    fontSize: 14,
                    fontWeight: 500
                })
            }
        }
    }

})
export default responsiveFontSizes(theme)
